import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=00477724&scoped=true"
import script from "./OrderBook.vue?vue&type=script&lang=js"
export * from "./OrderBook.vue?vue&type=script&lang=js"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=00477724&prod&lang=scss"
import style1 from "./OrderBook.vue?vue&type=style&index=1&id=00477724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00477724",
  null
  
)

export default component.exports